import { Route } from '@/routes';

export const isOptimizationService = (serviceName: string | undefined) => {
  return (
    serviceName === Route.FLOOR_PLAN ||
    serviceName === Route.CEILING_PLAN ||
    serviceName === Route.PLANT_ROOM ||
    serviceName === Route.SPACE_ANALYSIS ||
    serviceName === Route.PARKING ||
    serviceName === Route.REPORTS
  );
};
